import React from 'react';

const PlanCardPricing = ({
  tier,
  period,
  blackFridayOfferType,
  selectedPeriod,
  getPlanSavings,
  tiers,
}) => {
  const tierName = tier.name?.toLowerCase();

  // Check for $5 Monthly Starter offer
  const showFiveDollarOffer = false;

  const showBlackFridayPricing =
    blackFridayOfferType === 'free_tier' && selectedPeriod === 'monthly' && !showFiveDollarOffer;

  // Show $5 offer for Starter monthly
  if (showFiveDollarOffer) {
    const originalPrice = tier.price;
    // Starter: $5 now, $14.50 next month, then $40 after

    return (
      <div className="flex flex-col gap-v3-xxs items-center justify-center my-v3-sm">
        <div className="flex items-center justify-center gap-v3-xs">
          <span className="font-inter-variable text-lg font-regular line-through text-v3-black-secondary">
            ${originalPrice}
          </span>
        </div>
        <div className="flex items-center justify-center">
          <span className="font-inter-variable text-v3-h3 font-bolder text-v3-black-max">
            $5
          </span>
          <span className="font-inter-variable text-v3-h5 font-bolder leading-[20px] text-v3-black-max">
            /month
          </span>
        </div>
        <span className="text-v3-h9 font-bold text-v3-green-dark">
          $5 now, $14.50 next month, then $40 after
        </span>
      </div>
    );
  }

  if (showBlackFridayPricing) {
    const originalPrice = tier.price;

    // Savings per month for each tier
    const savingsMap = {
      'starter': 7,
      'advanced': 17,
      'pro': 57,
    };

    const monthlySavings = savingsMap[tierName] || 0;

    return (
      <div className="flex flex-col gap-v3-xxs items-center justify-center my-v3-sm">
         <div className="flex items-center justify-center gap-v3-xs min-h-[22px]">
          <span className="font-inter-variable text-lg font-regular line-through text-v3-black-secondary ">
           
          </span>
        </div>
        <div className="flex items-center justify-center">
          <span className="font-inter-variable text-v3-h3 font-bolder text-v3-black-max">
            ${originalPrice}
          </span>
          <span className="font-inter-variable text-v3-h5 font-bolder leading-[20px] text-v3-black-max">
            /month
          </span>
        </div>
        {monthlySavings > 0 && (
          <span className="text-v3-h9 font-bold text-v3-green-dark">
            save ${monthlySavings} per month
          </span>
        )}
      </div>
    );
  }

  const displayPrice = tier.price;
  const periodLabel =
    period === 'yearly'
      ? 'year'
      : period === 'monthly'
      ? 'month'
      : 'week';

  return (
    <div className="flex flex-col gap-v3-xs items-center justify-center mt-v3-md mb-v3-lg">
      <div className="flex items-center justify-center">
        <span className="font-inter-variable text-v3-h3 font-bolder text-v3-black-max">
          ${displayPrice}
        </span>
        <span className="font-inter-variable text-v3-h3 font-bolder leading-[20px] text-v3-black-max">
          /{periodLabel}
        </span>
      </div>
      {period === 'yearly' && (
        <span className="font-inter-variable text-sm font-regular leading-[20px] text-v3-black-primary">
          billed annually
        </span>
      )}
      {period === 'weekly' && (
        <span className="font-inter-variable text-sm font-regular leading-[20px] text-v3-black-primary">
          billed weekly
        </span>
      )}
      {period !== 'weekly' && (
        <span className="text-v3-h9 font-bold text-v3-green-dark">
          Save $
          {getPlanSavings(
            tier.price,
            tiers?.['monthly']?.find((t) => t.name === tier.name)?.price,
            tiers?.['weekly']?.find((t) => t.name === tier.name)?.price
          )}{' '}
          per {period === 'yearly' ? 'year' : period === 'monthly' ? 'month' : 'week'}
        </span>
      )}
    </div>
  );
};

export default PlanCardPricing;

